import React, { Component } from "react";
import PropTypes from "prop-types";
import { SketchPicker, BlockPicker } from "react-color";

export default class ObjectsInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayColorPicker: false
    };
  }
  updateState = e => {
    this.props.updateStateFromInput({
      name: e.target.name,
      value: e.target.value,
      id: this.props.selected[0]
    });
  };
  handleColorPicker = color => {
    console.log(color);
    this.props.updateBackground(color.hex);
  };
  onSelectSize = e => {
    var size = e.target.value;
    size = size.split("x");
    this.props.updateSize({
      width: size[0],
      height: size[1]
    });
  };
  render() {
    var scene = this.props.scenes[this.props.scene];
    const { objects, width, height } = scene;
    const size = `${width}x${height}`;

    if (this.props.sceneActive) {
      return (
        <div id="">
          <div className="objects-info sidebar-container sidebar-inspector">
            <div className="properties-panel scene" style={{}}>
              <div
                data-property-row="canvas-size"
                className="ill-property-row no-label"
              >
                <div className="columns">
                  <div className="column" style={{ width: "25%" }}>
                    <div className="content">
                      <div data-property="bck" className="ill-pattern-chooser">
                        <span
                          className="preview ill-button"
                          draggable="true"
                          onClick={() => {
                            this.setState(state => ({
                              displayColorPicker: !state.displayColorPicker
                            }));
                          }}
                          style={{
                            height: "26px",
                            minWidth: "20px",
                            background: scene.background
                          }}
                        >
                          {this.state.displayColorPicker ? (
                            <div className="color-picker-wrapper">
                              <SketchPicker
                                color={scene.background}
                                onChangeComplete={this.handleColorPicker}
                              />
                            </div>
                          ) : null}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="column" style={{ width: "37.5%" }}>
                    <div className="content">
                      <div>
                        <span className="ill-input-label">w</span>
                        <input
                          className="wh"
                          type="text"
                          data-property="w"
                          style={{ paddinillLeft: "20px", width: "100%" }}
                          value={scene.width}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                  <div className="column" style={{ width: "37.5%" }}>
                    <div className="content">
                      <div>
                        <span className="ill-input-label">h</span>
                        <input
                          type="text"
                          className="wh"
                          data-property="h"
                          style={{ paddinillLeft: "20px", width: "100%" }}
                          value={scene.height}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="labels">
                  <label style={{ width: "25%" }}>
                    <span>Color</span>
                  </label>
                  <label style={{ width: "37.5%" }}>
                    <span>Width</span>
                  </label>
                  <label style={{ width: "37.5%" }}>
                    <span>Height</span>
                  </label>
                </div>
              </div>
              <hr />
              <div className="ill-property-row no-label">
                <div className="columns">
                  <div className="column" style={{ width: "25%" }}>
                    <div className="content">
                      <span>Size</span>
                    </div>
                  </div>
                  <label className="column" style={{ width: "75%" }}>
                    <div className="content">
                      <select
                        data-property="preset-size"
                        style={{ width: "100%" }}
                        disabled={objects.length === 0 ? false : true}
                        onChange={this.onSelectSize.bind(this)}
                        value={size}
                      >
                        <optgroup label="Custom Size">
                          <option value="full">Custom Width</option>
                        </optgroup>
                        <optgroup label="Web">
                          <option value="560x315">Blog Cover</option>
                          <option value="800x1200">Blog Graphic</option>
                          <option value="1024x768">Website - Small</option>
                          <option value="1280x800">Website - Normal</option>
                          <option value="1366x768">Website - Medium</option>
                          <option value="1440x900">Website - Large</option>
                          <option value="1920x1280">Website - Huge</option>
                          <option value="1440x3072">Full Website</option>
                        </optgroup>
                        <optgroup label="Social">
                          <option value="851x315">Facebook Cover</option>
                          <option value="1500x500">Twitter Cover</option>
                          <option value="2560x1440">YouTube Cover</option>
                          <option value="1080x608">Google+ Cover</option>
                          <option value="1440x425">LinkedIn Cover</option>
                          <option value="900x480">Twitch Cover</option>
                          <option value="1024x512">Twitter Post</option>
                          <option value="940x788">Facebook Post</option>
                          <option value="810x450">Facebook App</option>
                          <option value="1200x627">Facebook Ad</option>
                          <option value="1080x1080">Instagram Post</option>
                          <option value="540x810">Tumblr Graphic</option>
                          <option value="735x600">Pinterest Pin</option>
                          <option value="1206x708">Twitch Video</option>
                          <option value="646x220">LinkedIn Banner</option>
                          <option value="400x300">Dribble Shot</option>
                          <option value="800x600">Dribble Shot</option>
                        </optgroup>
                        <optgroup label="Screen">
                          <option value="375x812">iPhone X</option>
                          <option value="828x1792">iPhone XR</option>
                          <option value="1242x2688">iPhone XS Max</option>
                          <option value="414x736">iPhone 6/7/8 Plus</option>
                          <option value="375x667">iPhone 6/7/8</option>
                          <option value="320x568">iPhone 5/SE</option>
                          <option value="411x731">Google Pixel 2/XL</option>
                          <option value="360x640">Android mobile</option>
                          <option value="272x340">Apple Watch 38mm</option>
                          <option value="312x390">Apple Watch 42mm</option>
                          <option value="324x394">Apple Watch 4 40mm</option>
                          <option value="368x448">Apple Watch 4 44mm</option>
                        </optgroup>
                        <optgroup label="Screen">
                          <option value="768x1024">iPad 3/4/Air/Mini</option>
                          <option value="1024x1366">iPad Pro 12.9in</option>
                          <option value="600x960">Nexus 7</option>
                          <option value="1024x768">Nexus 9</option>
                          <option value="1280x800">Nexus 10</option>
                          <option value="1440x960">Surface Pro 3</option>
                          <option value="1368x912">Surface Pro 4</option>
                        </optgroup>
                      </select>
                    </div>
                  </label>
                </div>
              </div>
              <hr data-property-row="fixed-size" />
              <div
                data-property-row="fixed-size"
                className="ill-property-row no-label"
              >
                <div className="columns">
                  <div className="column" style={{ width: "25%" }}>
                    <div className="content">
                      <span>Margin</span>
                    </div>
                  </div>
                  <label className="column" style={{ width: "18.75%" }}>
                    <div className="content">
                      <input
                        defaultValue="0"
                        readOnly
                        type="text"
                        data-property="ml"
                      />
                    </div>
                  </label>
                  <label className="column" style={{ width: "18.75%" }}>
                    <div className="content">
                      <input
                        defaultValue="0"
                        readOnly
                        type="text"
                        data-property="mt"
                      />
                    </div>
                  </label>
                  <label className="column" style={{ width: "18.75%" }}>
                    <div className="content">
                      <input
                        defaultValue="0"
                        readOnly
                        type="text"
                        data-property="mr"
                      />
                    </div>
                  </label>
                  <label className="column" style={{ width: "18.75%" }}>
                    <div className="content">
                      <input
                        defaultValue="0"
                        readOnly
                        type="text"
                        data-property="mb"
                      />
                    </div>
                  </label>
                </div>
                <div className="labels" style={{ marginLeft: "25%" }}>
                  <label style={{ width: "25%" }}>
                    <span>Left</span>
                  </label>
                  <label style={{ width: "25%" }}>
                    <span>Top</span>
                  </label>
                  <label style={{ width: "25%" }}>
                    <span>Right</span>
                  </label>
                  <label style={{ width: "25%" }}>
                    <span>Bottom</span>
                  </label>
                </div>
              </div>
              <hr data-property-row="fixed-size" />
              <div className="ill-property-row no-label">
                <div className="columns">
                  <div className="column" style={{ width: "25%" }}>
                    <div className="content">
                      <span>Units</span>
                    </div>
                  </div>
                  <label className="column" style={{ width: "75%" }}>
                    <div className="content">
                      <select
                        data-property="preset-unit"
                        style={{ width: "100%" }}
                        disabled={objects.length === 0 ? false : true}
                        value={scene.units}
                      >
                        <option value="px">Pixels</option>
                        <option value="mm">Millimeters</option>
                        <option value="%">Percentage</option>
                        <option value="cm">Centimeters</option>
                        <option value="in">Inches</option>
                        <option value="pc">Picas</option>
                        <option value="pt">Points</option>
                      </select>
                    </div>
                  </label>
                </div>
              </div>
              <hr data-property-row="fixed-size" />
            </div>
          </div>
        </div>
      );
    }
    if (this.props.selected) var object = objects[this.props.selected[0]];
    if (!object) return null;

    return (
      <div id="">
        <div className="objects-info sidebar-container sidebar-inspector">
          {this.props.selected.length >= 1 && (
            <>
              <div className="properties-panel">
                <div className="ill-property-row">
                  <label>Position</label>
                  <div className="columns">
                    <div className="column" style={{ width: "50%" }}>
                      <div className="content">
                        <div>
                          <span className="ill-input-label">x</span>
                          <input
                            type="number"
                            data-dimension="x"
                            name="x"
                            style={{ paddingLeft: "20px", width: "100%" }}
                            value={object.x}
                            onChange={this.updateState}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="column" style={{ width: "50%" }}>
                      <div className="content">
                        <div>
                          <span className="ill-input-label">y</span>
                          <input
                            type="number"
                            data-dimension="y"
                            name="y"
                            style={{ paddingLeft: "20px", width: "100%" }}
                            value={object.y}
                            onChange={this.updateState}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="ill-property-row">
                  <label>Size</label>
                  <div className="columns">
                    <div className="column" style={{ width: "50%" }}>
                      <div className="content">
                        <div>
                          <span className="ill-input-label">w</span>
                          <input
                            type="number"
                            data-dimension="w"
                            name="width"
                            style={{ paddingLeft: "20px", width: "100%" }}
                            value={object.width}
                            onChange={this.updateState}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="column" style={{ width: "50%" }}>
                      <div className="content">
                        <div>
                          <span className="ill-input-label">h</span>
                          <input
                            type="number"
                            name="height"
                            data-dimension="h"
                            style={{ paddingLeft: "20px", width: "100%" }}
                            value={object.height}
                            onChange={this.updateState}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="ill-property-row">
                  <label>Degree</label>
                  <div className="columns">
                    <div className="column" style={{ width: "50%" }}>
                      <div className="content">
                        <div>
                          <span className="ill-input-label">D</span>
                          <input
                            type="text"
                            data-dimension="rotate"
                            defaultValue={
                              object.degree ? object.degree + "°" : 0 + "°"
                            }
                            style={{ paddingLeft: "20px", width: "100%" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}
